import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAtmedHomeFeedBack,
} from '../../../store/actions';
import FeedBack from './Feedback';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  allHomeFeedbackHome: vendorEquipmenReducer.allHomeFeedbackHome,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAtmedHomeFeedBack,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);
